/**
 * Not mandatory but if the env is not present here,
 * a warn will be shown in the console:
 * WARN: Add env to whitelist list (envs-config.js)
 */
export const whitelistedEnvs = {
  messagesSearchMaxDatesPerReq:
    'Messages module - Max number of dates per request (Sent messages tab)',
  messagesSearchMaxVehiclesPerReq:
    'Messages module - Max number of vehicles per request (Sent messages tab)',
  messagesSearchMaxParallelReq:
    'Messages module - Max number of parallel request (Sent messages tab)',
  messagesFeatureSearchSelectionLimit:
    'Messages module - Max selection limit (vehicles*dates)',
  apiWrapperPoolingMaxParallelReq: '',
  alertsSearchMaxDatesPerReq: '',
  alertsSearchMaxVehiclesPerReq: '',
  alertsSearchMaxParallelReq: '',
  alertsSearchMaxSelectionLimit: '',
  alertsSearchDisableAutomaticSearch: '',
  identificationSearchSynthesisItemsSize:
    'Identification - Synthesis - Max vehicles per request',
  identificationSearchMaxParallelRequests:
    'Identification - Details - Max parallel requests',
  identificationSearchSynthesisMaxParallelRequests:
    'Identification - Synthesis - Max parallel requests',
  identificationMaxMapRenderedItems:
    'Limit the number of items rendered on the map',
  locationFetchVehicleDataDisableValidateBtnMaxDuration:
    'Value in milliseconds, default to 5000',
  containersModuleMapSpiderfyOnMaxZoom:
    'Allow viewing markers that collide each other',
  disableRightsCheck: 'Can disable rights check on staging envs',
  clientLogoUri: 'API URL, defaults to /geored/client/logos',
  containersModuleAddressSearchRadius: 'Defaults to 100m',
  containersModuleItemsPerPage: '',
  containersModuleMaxAllowedItems: '',
  clientParametersUri: 'API URL, defaults to /geored/client_parameters',
  googleGeocoding: 'API URL, defaults to /service/cartography/google',
  releaseName: 'Set during CI',
  sentryDsn: 'Sentry server URL',
  apiChronoImputationsUri: 'API URL',
  geonlineNewsApiHostUrl: 'API to retrieve app notices/news',
  messagesTestStatus: 'Debug/Test messages module statuses 0/1',
  googleKey: 'Google key for geocoding',
  autocompleteDefaultProvider:
    'Autocomplete default provider osm/simpliciti_v3/simpliciti_v3_google',
  containersModuleDisableAutorefreshSettings:
    'Disable autorefresh WS feat 1 by default',
  disableUserAudit: 'Disable APIV2 audit logs',
  citipavHost: 'APP URL',
  citifretHost: 'APP URL',
  citiMissionHost: 'APP URL',
  citiBoardHost: 'APP URL',
  containersModuleCurrentStatesAPIParamExistsBinIdTrue:
    '1 to skip puce sans bac data',
  globalFeatureSwitchableLeafletMarkerPopupMatchRadius: '20 by default',
  rights: '?rigths=0 to disable rights on staging envs',
  remove_rights: '?remove_rigths=right1,right2 (staging only)',
  add_rights: '?add_rights=right1,right2 (staging only)',
  rights_ignore_sabadmin:
    '?rights_ignore_sabadmin=0 (disables sabadmin bypass check) (staging only)',
  featureMapSelectablePolylineEnabled: 'Enabled by default',
  locationSearchItemsSize: '',
  locationSearchVehicleSize: '',
  locationSearchDriverSize: '',
  locationSearchCircuitSize: '',
  location_search_max_parallel_requests: '10 by default',
  location_has_data_check_skip_if_cached: '',
  test: 'Sometimes will mock data or enable some test behaviour (staging envs only)',
  use_apiv2:
    'Used by getTripHistoryFromVehicleId api to fallback to apiv2 (deprecated)',
}

let envsTable = {
  VITE_ROUTER_DEFAULT_ROUTE: 'VITE_ROUTER_DEFAULT_ROUTE',
  VITE_API_GEORED_HOST: 'VITE_API_GEORED_HOST',
  VITE_RELEASE_NAME: 'VITE_RELEASE_NAME',
  VITE_RELEASE_TIMESTAMP: 'VITE_RELEASE_TIMESTAMP',
  VITE_DISABLE_USER_AUDIT: 'VITE_DISABLE_USER_AUDIT',
  VITE_FILTERS_MAX_SELECTION: 'VITE_FILTERS_MAX_SELECTION',
  VITE_FILTERS_MAX_SELECTION_DATES: 'VITE_FILTERS_MAX_SELECTION_DATES',
  VITE_IDENTIFICATION_MODULE_SEARCH_SELECTION_LIMIT:
    'VITE_IDENTIFICATION_MODULE_SEARCH_SELECTION_LIMIT',
  VITE_SEARCH_SELECTION_LIMIT: 'VITE_SEARCH_SELECTION_LIMIT',
  VITE_CLIENT_PARAMETERS_URI: 'VITE_CLIENT_PARAMETERS_URI',
  VITE_GOOGLE_GEOCODING: 'VITE_GOOGLE_GEOCODING',
  VITE_AUTOCOMPLETE_DEFAULT_PROVIDER: 'VITE_AUTOCOMPLETE_DEFAULT_PROVIDER',
  VITE_GEORED_HOST: 'VITE_GEORED_HOST',
  VITE_CITIFRET_HOST: 'VITE_CITIFRET_HOST',
  VITE_CITIPAV_HOST: 'VITE_CITIPAV_HOST',
  VITE_GOOGLE_KEY: 'VITE_GOOGLE_KEY',
  VITE_APP_GEONLINE_NEWS_API_HOST_URL: 'VITE_APP_GEONLINE_NEWS_API_HOST_URL',
  VITE_AUTOREFRESH_INTERVAL: 'VITE_AUTOREFRESH_INTERVAL',
  events_enable_group_all: 'VITE_EVENTS_CAN_GROUP_EVENTS_BY_ALL',

  IFRAME_WHITELIST_URLS: 'VITE_IFRAME_WHITELIST_URLS',

  VITE_LASTPASSEDVEHICLES_FEATURE_SEARCH_SELECTION_LIMIT:
    'VITE_LASTPASSEDVEHICLES_FEATURE_SEARCH_SELECTION_LIMIT',
  VITE_MESSAGES_FEATURE_SEARCH_SELECTION_LIMIT:
    'VITE_MESSAGES_FEATURE_SEARCH_SELECTION_LIMIT',

  //Querystring parameters used in staging envs (fake envs) (only used via URL)

  /**
   * Replace statuses with each available status to test icons/labels.
   * @type {string}
   */
  messagesTestStatus: 'messagesTestStatus',
  blackspot_import_max_radius: 'VITE_BLACKSPOT_IMPORT_MAX_RADIUS_METERS',
  blackspot_import_max_entries_per_request:
    'VITE_BLACKSPOT_IMPORT_MAX_ENTRIES_PER_REQUEST',
  blackspot_max_segments_parts:
    'VITE_BLACKSPOT_MAX_SEGMENTS_PARTS_PER_BLACKSPOT',
  blackspot_max_segment_distance_meters:
    'VITE_BLACKSPOT_MAX_SEGMENT_DISTANCE_METERS',
  VITE_LOCATION_SEARCH_SELECTION_LIMIT: 'VITE_LOCATION_SEARCH_SELECTION_LIMIT',

  location_search_max_parallel_requests:
    'VITE_LOCATION_SEARCH_MAX_PARALLEL_REQUESTS',

  //1 : Could give problems if data becomes available with delay (e.g box went offline)
  //0 : More API requests
  location_has_data_check_skip_if_cached:
    'VITE_LOCATION_HAS_DATA_CHECK_SKIP_IF_CACHED',

  events_search_cumulation_items_size:
    'VITE_EVENTS_SEARCH_CUMULATION_ITEMS_SIZE',
  events_search_cumulation_max_parallel_requests:
    'VITE_EVENTS_SEARCH_CUMULATION_MAX_PARALLEL_REQUEST',

  eventsMaxParallelReq: 'VITE_EVENTS_SEARCH_DETAILS_MAX_PARALLEL_REQ',
  eventsDetailsMaxItemsPerReq: 'VITE_EVENTS_SEARCH_DETAILS_MAX_ITEMS_PER_REQ',
  eventsDetailsMaxDatesPerReq: 'VITE_EVENTS_SEARCH_DETAILS_MAX_DATES_PER_REQ',
}

//Add whitelisted envs to envsTable if missing
Object.keys(whitelistedEnvs).forEach((key) => {
  if (!Object.keys(envsTable).includes(key)) {
    envsTable[key] = key
  }
})

export const envNames = envsTable

/**
 * Convert a camelCase string to a VITE_ format
 * @param {String} input i.g maxSelection
 * @returns {String} i.g VITE_MAX_SELECTION
 */
export function toEnvFormat(input) {
  if (input.startsWith('VITE_')) {
    return input
  }
  // Split on capital letters
  let words = input.split(/(?=[A-Z])/)

  // Join with underscores and uppercase
  return 'VITE_' + words.join('_').toUpperCase()
}

/**
 * Convert a VITE_ format to a camelCase string
 * @param {String} input i.g VITE_MAX_SELECTION
 * @returns {String} i.g maxSelection
 */
export function toFriendlyNameFormat(input) {
  // If input is already in camelCase format, return it as is
  if (!input.includes('_')) {
    return input
  }

  // Remove the "VITE_" prefix
  let withoutPrefix = input.replace(/^VITE_/, '')

  // Split by underscores and convert to camelCase
  let parts = withoutPrefix.toLowerCase().split('_')
  let result = parts[0]

  for (let i = 1; i < parts.length; i++) {
    result += parts[i].charAt(0).toUpperCase() + parts[i].slice(1)
  }

  return result
}
